export default function getEventClassName(eventDuration) {
    var lessHalfHourEventDuration = eventDuration < 30;
    var halfHourToHourEventDuration = eventDuration >= 30 && eventDuration < 60;
    var oneHourEventDuration = eventDuration === 60;
    var moreOneHourEventDuration = eventDuration > 60;
    var classes = {
        lessHalfHourEventDuration: 'LessHalfHourEvent',
        halfHourToHourEventDuration: 'HalfHourToHourEvent',
        oneHourEventDuration: 'OneHourEvent',
        moreOneHourEventDuration: 'MoreOneHourEvent',
    };
    return ((lessHalfHourEventDuration && classes.lessHalfHourEventDuration) ||
        (halfHourToHourEventDuration && classes.halfHourToHourEventDuration) ||
        (oneHourEventDuration && classes.oneHourEventDuration) ||
        (moreOneHourEventDuration && classes.moreOneHourEventDuration));
}
//# sourceMappingURL=getEventClassName.js.map